import { calculatePercentage } from "@utilities/calculate-percentage";
export class AccountAnalytics {
    accounts;
    invites;
    constructor(accounts, invites) {
        this.accounts = accounts;
        this.invites = invites;
    }
    /**
     * Calculates the conversion percentage for invites
     * @returns Rounded percentage number for conversions
     */
    invitesConversionPercentage() {
        return calculatePercentage(this.invites, this.accounts);
    }
}
